import { useSelector } from 'react-redux';

export function getAccount(state) {
  return state.auth?.account;
}

export default function useAccount() {
  return useSelector(getAccount);
}
